<!-- 
  金额面板
  lovi 2020-07-02
 -->
<template>
  <div class="money-list">
    <ul :class="{ moreMoney: moreFlag }">
      <li
        :class="{ active: moneyId == item.denomination_id }"
        v-for="(item, index) in list"
        :key="index"
        @click="chooseMoney(item.amount, item.denomination_id)"
      >
        <h3>{{ item.amount }}P</h3>
        <p v-if="rate">
          {{ $t("common.price") }}
          {{ _PHPtoRMB(Number(item.amount), rate) }}
          {{ $t("common.CNY") }}
        </p>
      </li>
      <li class="placeholder-li"></li>
      <li class="placeholder-li"></li>
      <li class="placeholder-li"></li>
    </ul>
    <div class="more" v-if="list.length > 6">
      <span @click="moreFlag = !moreFlag">
        {{ $t("common.moreDenomination") }}
        <Icon :class="{ rotate: moreFlag }" type="md-arrow-dropdown" />
      </span>
    </div>
    <div class="custom-recently">
      <div class="custom" v-if="custom.amount_mini">
        <label>{{ $t("wallet.customizedAmount") }}：</label>
        <InputNumber
          v-model="enter_amount"
          :min="0"
          :precision="2"
          @on-change="inputAmount"
          :placeholder="
            $t('common.customized') +
              custom.amount_mini +
              '-' +
              custom.amount_max
          "
        />
        <label class="marginR">P</label>
      </div>
      <p class="recently">
        <a href="javascript:void(0)" @click="clickRecently">
          {{ $t("common.recentChargeAmount") }}
          {{ Number(recently).toFixed(2) }}P,
          {{ $t("common.clickContinueRecharge") }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      // 金额列表
      type: Array,
      default: function() {
        return [];
      }
    },
    rate: {
      //汇率
      type: Number,
      default: function() {
        return 0;
      }
    },
    custom: {
      //自定义信息
      type: Object,
      default: function() {
        return {};
      }
    },
    money: {
      //金额
      type: Number,
      default: function() {
        return 0;
      }
    },
    moneyId: {
      //金额Id
      type: Number,
      default: function() {
        return 0;
      }
    },
    recently: {
      //最近充值
      type: String,
      default: function() {
        return "";
      }
    }
  },
  components: {},
  data() {
    return {
      moreFlag: false,
      enter_amount: null, //输入金额
      quick_amount: null, //快捷金额
      quick_id: 0 //金额Id
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    chooseMoney(money, id) {
      //选择金额
      let vm = this;
      vm.quick_amount = Number(money);
      vm.quick_id = Number(id);
      vm.$emit("update:money", vm.quick_amount);
      vm.$emit("update:moneyId", vm.quick_id);
      vm.enter_amount = null;
    },
    inputAmount() {
      //输入金额
      let vm = this;
      vm.quick_amount = null;
      vm.quick_id = 0;
      vm.$emit("update:money", Number(vm.enter_amount));
      vm.$emit("update:moneyId", 0);
    },
    clickRecently() {
      //点击最近充值
      let vm = this;
      vm.enter_amount = Number(vm.recently);
      vm.quick_amount = null;
      vm.quick_id = 0;
      vm.$emit("update:money", vm.quick_amount);
    },
    _getDefaultMoney(arr) {
      // 获取默认金额
      let vm = this;
      for (let i = 0; i < arr.length; i++) {
        if (vm.moneyId) {
          vm.quick_amount = vm.money;
          vm.quick_id = vm.moneyId;
          return false;
        }
        if (vm.money) {
          vm.enter_amount = vm.money;
          return false;
        }
        if (arr[i].default) {
          vm.quick_amount = Number(arr[i].amount);
          vm.quick_id = Number(arr[i].denomination_id);
          vm.$emit("update:money", vm.quick_amount);
          vm.$emit("update:moneyId", vm.quick_id);
        }
      }
    }
  },
  watch: {
    moneyId(obj) {
      if (obj) {
        this.enter_amount = null;
      }
    },
    list: {
      handler(arr) {
        if (arr.length) {
          console.log("handler");
          this._getDefaultMoney(arr);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.money-list {
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: -10px;
    max-height: 64px;
    overflow: hidden;
    &.moreMoney {
      max-height: initial;
    }
    li {
      cursor: pointer;
      display: flex;
      justify-content: center;
      flex-flow: column;
      margin-right: 15px;
      margin-top: 10px;
      padding: 0 10px;
      text-align: center;
      min-width: 88px;
      height: 54px;
      line-height: 1;
      color: #9b9b9b;
      background: #fff;
      border: 1px solid #ccc;
      border-radius: 5px;
      &.placeholder-li {
        border: 0;
        margin: 0;
        padding: 0;
        height: 0;
      }
      &.active {
        color: #fff;
        background: linear-gradient(
          90deg,
          rgba(32, 67, 172, 1) 0%,
          rgba(19, 15, 115, 1) 100%
        );
        border-color: rgba(32, 67, 172, 1);
      }
      h3 {
        font-weight: 400;
      }
      p {
        margin-top: 4px;
        font-size: 10px;
        // transform: scale(0.9)
      }
    }
  }
  .more {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    span {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      /deep/.ivu-icon {
        margin-left: 2px;
        font-size: 18px;
        transition: transform 0.5s;
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
  }
  .custom-recently {
    margin-top: 10px;
    /deep/.ivu-input-wrapper,
    /deep/.ivu-input-number {
      width: 200px;
      margin-right: 10px;
    }
    .marginR {
      margin-right: 10px;
    }
    .recently {
      // text-align: right;
      a {
        cursor: pointer;
        font-size: 12px;
        color: #fe7800;
      }
    }
  }
}
</style>
